var render = function render(){var _vm=this,_c=_vm._self._c;return _c('font-awesome-icon',{style:({color: _vm.color}),attrs:{"icon":_vm.icon,"fixed-width":"","spin":_vm.loading,"title":_vm.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }